module.exports = require("swagger-client");


//////////////////
// WEBPACK FOOTER
// external "swagger-client"
// module id = 243
// module chunks = 0